import "../../index82.css";
import { jsx as l } from "react/jsx-runtime";
import { _ as i } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import r from "../../hooks/useTranslation.js";
const u = "common", c = {
  booleanYesLabel: "Yes",
  booleanNoLabel: "No"
}, m = {
  namespace: u,
  strings: c
}, p = "_boolean-output_kg1uq_1", b = {
  booleanOutput: p
};
function L(s) {
  const {
    className: n,
    invalidText: a,
    value: e
  } = s, t = r(m);
  let o;
  return e === !0 ? o = t.booleanYesLabel : e === !1 ? o = t.booleanNoLabel : o = a, /* @__PURE__ */ l("div", { className: i(b.booleanOutput, n), children: o });
}
export {
  L as default
};
